import '~/app.css';
import ScrollDownHint from './utilities/ScrollDownHint.js';

// DOM読み込み完了後に初期化
document.addEventListener('DOMContentLoaded', () => {
  // スクロールダウンヒントを初期化
  new ScrollDownHint();
});

/**
 * エラーメッセージをアラート表示
 */
const showErrorAlert = (details) => {
  alert(`エラーが発生しました:\n\n${details}\n\nページをリロードしてください。`);
};

/**
 * グローバルエラーハンドラー（同期エラー）
 */
window.addEventListener('error', (event) => {
  console.error('Uncaught error:', event.error);
  const details = [
    `メッセージ: ${event.message || 'Unknown'}`,
    `ファイル: ${event.filename || 'Unknown'}`,
    `行: ${event.lineno || '?'}, 列: ${event.colno || '?'}`,
    event.error?.stack ? `\nスタック:\n${event.error.stack}` : ''
  ].filter(Boolean).join('\n');
  showErrorAlert(details);
});

/**
 * グローバルエラーハンドラー（Promise rejection）
 */
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled rejection:', event.reason);
  const error = event.reason;
  const details = [
    `メッセージ: ${error?.message || error || 'Unknown'}`,
    error?.stack ? `\nスタック:\n${error.stack}` : ''
  ].filter(Boolean).join('\n');
  showErrorAlert(details);
});

// ヘッダーロゴにクエリパラメータを設定
const headerLogo = document.querySelector('[data-ref="headerLogo"]');
if (headerLogo && window.location.search) {
  headerLogo.href = '/' + window.location.search;
}